import { createApp } from "vue";
import { setupCalendar } from 'v-calendar';
import Notifications from '@kyvg/vue3-notification';
import velocity from "velocity-animate";
import TrainerSearch from "./TrainerSearch.vue";
import { getPinia } from "@/shared/pinia";

const app = createApp(TrainerSearch);
app.use(getPinia());
app.use(setupCalendar, {});
app.use(Notifications, { velocity });

if (document.getElementById('trainer-search')) {
    app.mount("#trainer-search");
}